import { useQuery } from "@tanstack/react-query";
import { getVacancies } from "../api/vacancyApi";
import { vacancyKeys } from "../api/vacancyKeys";

// Listado completo de vacantes (la paginación y el filtro son client-side).
export const useVacancies = () =>
  useQuery({
    queryKey: vacancyKeys.list(),
    queryFn: getVacancies,
  });
